// Hofstra University's undergraduate majors (#2743). Read on 2026-10-01 from
// the official 2026-2027 Undergraduate Bulletin (bulletin.hofstra.edu,
// catoid=147): each college and school page lists its programs, and every
// "Major in" entry there is kept with the degree the bulletin names (BA, BS,
// BBA, BFA, BSEd, BE). Physician Assistant Studies, a BS and MS dual degree
// open only to first-year students, is kept as one line; the other combined
// bachelor's and master's programs, minors and certificates are left out.
// Three majors in the bulletin's university-wide program list (Africana
// Studies, Art History, Criminology) appear on no school page, so they sit
// in their own group sourced to that list. Names are the bulletin's, without
// the trailing "Major in". The KB's majors list was the starting point; the
// bulletin wins.
const majors = {
    "slug": "hofstra-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Hofstra's official 2026-2027 Undergraduate Bulletin, grouped by the college or school that lists it, with the degree it leads to. Minors, certificates, combined bachelor's and master's programs and graduate programs are left out.",
    "groups": [
        {
            "name": "Hofstra College of Liberal Arts and Sciences",
            "source": {
                "label": "Hofstra 2026-2027 Undergraduate Bulletin, Hofstra College of Liberal Arts and Sciences",
                "url": "https://bulletin.hofstra.edu/content.php?catoid=147&navoid=28201"
            },
            "majors": [
                {
                    "name": "Labor Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latin American and Caribbean Studies",
                    "degree": "BA"
                },
                {
                    "name": "Liberal Arts",
                    "degree": "BA"
                },
                {
                    "name": "Pre-Health (Pre-Medical) Studies With a Concentration in Humanities or Social Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Women's Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Humanities, Fine and Performing Arts of HCLAS",
            "source": {
                "label": "Hofstra 2026-2027 Undergraduate Bulletin, School of Humanities, Fine and Performing Arts of HCLAS",
                "url": "https://bulletin.hofstra.edu/content.php?catoid=147&navoid=27994"
            },
            "majors": [
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Chinese",
                    "degree": "BA"
                },
                {
                    "name": "Comparative Literature and Languages",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BFA"
                },
                {
                    "name": "Drama",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Fine Arts",
                    "degree": "BS"
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": "BA"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "Greek and Roman Studies",
                    "degree": "BA"
                },
                {
                    "name": "Italian and Italian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Japanese",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BS"
                },
                {
                    "name": "Music Business",
                    "degree": "BA"
                },
                {
                    "name": "Rhetoric and Public Advocacy",
                    "degree": "BA"
                },
                {
                    "name": "Russian and Post-Soviet Studies",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Theater Arts",
                    "degree": "BFA"
                },
                {
                    "name": "Writing Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Natural Sciences and Mathematics of HCLAS",
            "source": {
                "label": "Hofstra 2026-2027 Undergraduate Bulletin, School of Natural Sciences and Mathematics of HCLAS",
                "url": "https://bulletin.hofstra.edu/content.php?catoid=147&navoid=27995"
            },
            "majors": [
                {
                    "name": "Applied Physics",
                    "degree": "BS"
                },
                {
                    "name": "Astronomy",
                    "degree": "BA"
                },
                {
                    "name": "Astrophysics",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biophysics",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Resources",
                    "degree": "BS"
                },
                {
                    "name": "Forensic Science",
                    "degree": "BS"
                },
                {
                    "name": "Geology",
                    "degree": "BA"
                },
                {
                    "name": "Geology",
                    "degree": "BS"
                },
                {
                    "name": "Mathematical Finance",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Pre-Medical Studies",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Science, Technology, Engineering and Mathematics (STEM)",
                    "degree": "BA"
                },
                {
                    "name": "Sustainability Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sustainability Studies",
                    "degree": "BS"
                },
                {
                    "name": "Urban Ecology",
                    "degree": "BA"
                },
                {
                    "name": "Urban Ecology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Peter S. Kalikow School of Government, Public Policy and International Affairs of HCLAS",
            "source": {
                "label": "Hofstra 2026-2027 Undergraduate Bulletin, Peter S. Kalikow School of Government, Public Policy and International Affairs of HCLAS",
                "url": "https://bulletin.hofstra.edu/content.php?catoid=147&navoid=27996"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics (Business)",
                    "degree": "BS"
                },
                {
                    "name": "Geographic Information Systems",
                    "degree": "BS"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Global Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Jewish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Mathematical Business Economics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematical Economics",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy and Public Service",
                    "degree": "BA"
                },
                {
                    "name": "Religion and Contemporary Issues",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Frank G. Zarb School of Business",
            "source": {
                "label": "Hofstra 2026-2027 Undergraduate Bulletin, Frank G. Zarb School of Business",
                "url": "https://bulletin.hofstra.edu/content.php?catoid=147&navoid=27985"
            },
            "majors": [
                {
                    "name": "Accounting - 120",
                    "degree": "BBA",
                    "note": "The 120-semester-hour program."
                },
                {
                    "name": "Accounting - 150",
                    "degree": "BBA",
                    "note": "The 150-semester-hour program."
                },
                {
                    "name": "Business Analytics",
                    "degree": "BBA"
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "BBA"
                },
                {
                    "name": "Finance",
                    "degree": "BBA"
                },
                {
                    "name": "Information Systems",
                    "degree": "BBA"
                },
                {
                    "name": "International Business",
                    "degree": "BBA"
                },
                {
                    "name": "Management",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Sports Management",
                    "degree": "BBA"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "BBA"
                }
            ]
        },
        {
            "name": "The Lawrence Herbert School of Communication",
            "source": {
                "label": "Hofstra 2026-2027 Undergraduate Bulletin, The Lawrence Herbert School of Communication",
                "url": "https://bulletin.hofstra.edu/content.php?catoid=147&navoid=28206"
            },
            "majors": [
                {
                    "name": "Broadcast and Streaming Journalism",
                    "degree": "BS"
                },
                {
                    "name": "Film Studies and Production",
                    "degree": "BA"
                },
                {
                    "name": "Filmmaking",
                    "degree": "BFA"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Mass Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "Podcasting and Audio Storytelling",
                    "degree": "BA"
                },
                {
                    "name": "Public Relations and Strategic Communication",
                    "degree": "BA"
                },
                {
                    "name": "Sports Media",
                    "degree": "BS"
                },
                {
                    "name": "Television",
                    "degree": "BS"
                },
                {
                    "name": "Television Production and Studies",
                    "degree": "BA"
                },
                {
                    "name": "Television and Business",
                    "degree": "BS"
                },
                {
                    "name": "Television and Film",
                    "degree": "BS"
                },
                {
                    "name": "Writing for the Screen",
                    "degree": "BFA"
                }
            ]
        },
        {
            "name": "School of Education",
            "source": {
                "label": "Hofstra 2026-2027 Undergraduate Bulletin, School of Education",
                "url": "https://bulletin.hofstra.edu/content.php?catoid=147&navoid=28205"
            },
            "majors": [
                {
                    "name": "Dance Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Early Childhood (Birth-Grade 2)/ Childhood Education (Grades 1-6)",
                    "degree": "BS"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BA"
                },
                {
                    "name": "English Education",
                    "degree": "BA"
                },
                {
                    "name": "Fine Arts Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Mathematics Education",
                    "degree": "BA"
                },
                {
                    "name": "Music Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Physical Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Science Education",
                    "degree": "BA"
                },
                {
                    "name": "Social Studies Education",
                    "degree": "BA"
                },
                {
                    "name": "World Language Education (French, Italian, Spanish, German or Russian)",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Fred DeMatteis School of Engineering and Applied Science",
            "source": {
                "label": "Hofstra 2026-2027 Undergraduate Bulletin, Fred DeMatteis School of Engineering and Applied Science",
                "url": "https://bulletin.hofstra.edu/content.php?catoid=147&navoid=28211"
            },
            "majors": [
                {
                    "name": "Bioengineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "BS"
                },
                {
                    "name": "Data Science and Machine Learning",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Science",
                    "degree": "BE"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "User Experience (UX) & Product Design",
                    "degree": "BA"
                },
                {
                    "name": "User Experience (UX) & Product Design",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Health Sciences",
            "source": {
                "label": "Hofstra 2026-2027 Undergraduate Bulletin, School of Health Sciences",
                "url": "https://bulletin.hofstra.edu/content.php?catoid=147&navoid=28215"
            },
            "majors": [
                {
                    "name": "Community Health",
                    "degree": "BS"
                },
                {
                    "name": "Exercise Physiology",
                    "degree": "BS"
                },
                {
                    "name": "Health Science",
                    "degree": "BS"
                },
                {
                    "name": "Speech-Language-Hearing Sciences",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Hofstra Northwell School of Nursing and Physician Assistant Studies",
            "source": {
                "label": "Hofstra 2026-2027 Undergraduate Bulletin, Hofstra Northwell School of Nursing and Physician Assistant Studies",
                "url": "https://bulletin.hofstra.edu/content.php?catoid=147&navoid=27993"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BS"
                },
                {
                    "name": "Physician Assistant Studies",
                    "degree": "BS/MS",
                    "note": "A dual-degree program: a BS and an MS in five and a half years, open only to first-year students."
                }
            ]
        },
        {
            "name": "Other majors in the bulletin",
            "source": {
                "label": "Hofstra 2026-2027 Undergraduate Bulletin, Programs (Alphabetically, University-wide)",
                "url": "https://bulletin.hofstra.edu/content.php?catoid=147&navoid=27986"
            },
            "note": "The bulletin lists these majors in its university-wide program list but not on a school page.",
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Criminology",
                    "degree": "BA"
                }
            ]
        }
    ]
};

export default majors;
